import { render } from "./magazinesFeature.vue?vue&type=template&id=4e479224&scoped=true"
import script from "./magazinesFeature.vue?vue&type=script&lang=js"
export * from "./magazinesFeature.vue?vue&type=script&lang=js"

import "./magazinesFeature.vue?vue&type=style&index=0&id=4e479224&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e479224"]])

export default __exports__